/* eslint-disable angular/factory-name */

angular.
module("dx.webapp.logging").
factory("dxRavenInterceptor", function RavenInterceptor(
	$q,
	Raven,
	$cookies
) {
	"use strict";

	function logRejection(rejection) {
		var message = "" + rejection.status;

		if (rejection.data && rejection.data.msgs && rejection.data.msgs.length !== 0) {
			message += ": " + rejection.data.msgs[0];
		} else {
			message += " " + rejection.statusText;
		}

		var ravenOptions = {
			extra: {
				config: rejection.config,
				status: rejection.status,
				statusText: rejection.statusText,
				responseData: rejection.data,
				cookies: $cookies.getAll(),
			},
		};

		Raven.captureMessage(message, ravenOptions);
	}

	function responseError(rejection) {
		var suppress = false;

		if (rejection.config.ravenSuppressCodes) {
			suppress = rejection.config.ravenSuppressCodes.indexOf(rejection.status) > -1;
		}

		if (!suppress && rejection.status >= 400 && rejection.status < 600) {
			logRejection(rejection);
		}

		return $q.reject(rejection);
	}

	return {
		responseError: responseError,
		logRejection: logRejection,
	};
});

